<template>
  <div>
    <arkidian
      style="margin:auto; background-color:#ececec; border-radius:50%; width:300px; margin-top:100px; margin-bottom:40px "
      :preferencias="preferencias"
    ></arkidian>



    <div
      v-if="preferencias.color != userLogged.preferencias.color || 
          preferencias.body != userLogged.preferencias.body ||
          preferencias.face != userLogged.preferencias.face ||
          preferencias.hair != userLogged.preferencias.hair"
      style="margin:auto; width:300px; margin-top:-50px; margin-bottom:10px; text-align: center "
    >
      <b-button
        v-if="hayAvatar"
        pill
        variant="success"
        @click="modificaAvatar(preferencias,userLogged.user)"
      >Aceptá los cambios        <img src="public/images/site/accept.svg" width=50 height=50>
</b-button>
      <b-button
        v-if="!hayAvatar"
        pill
        variant="success"
        @click="altaAvatar(preferencias,userLogged.user)"
      >Creá tu Arkidian  <img src="public/images/site/accept.svg" width=50 height=50></b-button>
    </div>
    <div style="margin:auto; width:300px; margin-top:10px; margin-bottom:10px ">
      <b-button pill @click="indColor=true; indBody=false; indFace= false; indHair = false">Color</b-button>
      <b-button pill @click="indColor=false; indBody=true; indFace= false; indHair = false">Cuerpo</b-button>
      <b-button pill @click="indColor=false; indBody=false; indFace= true; indHair = false">Cara</b-button>
      <b-button pill @click="indColor=false; indBody=false; indFace= false; indHair = true">Cabeza</b-button>
    </div>

    <transition name="slideAnim" type="animation">
      <div v-if="indColor" class="container">
        <div class="row avatar">
          <div class="container">
            <div class="row" style="justify-content: center; border-radius:15px">
              <div v-for="colorSelected in colors" v-bind:key="colorSelected">
                <div
                  :style="'width:30px; height:30px; background: '+colorSelected"
                  @click="seleccionaColor(colorSelected)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="indBody" class="container">
        <div class="row avatar">
          <div class="container">
            <div class="row" style="justify-content: center">
              <div v-for="body in bodies" v-bind:key="body">
                <img
                  :src="'public/images/arkidians/'+ body+'.svg'"
                  style="background-color:#ececec; border-radius:50%; width:100px; margin:10px"
                  class="img img-rounded img-fluid"
                  @click="seleccionaBody(body)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="indFace" class="container">
        <div class="row avatar">
          <div class="container">
            <div class="row" style="justify-content: center">
              <div v-for="face in faces" v-bind:key="face">
                <img
                  :src="'public/images/arkidians/'+ face+'.svg'"
                  style="background-color:#ececec; border-radius:50%; width:100px; margin:10px"
                  class="img img-rounded img-fluid"
                  @click="seleccionaFace(face)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="indHair" class="container">
        <div class="row avatar">
          <div class="container">
            <div class="row" style="justify-content: center">
              <div v-for="hair in hairs" v-bind:key="hair">
                <img
                  :src="'public/images/arkidians/'+ hair+'.svg'"
                  style="background-color:#ececec; border-radius:50%; width:100px; margin:10px"
                  class="img img-rounded img-fluid"
                  @click="seleccionaHair(hair)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import Arkidian from "../shared/Arkidian";
import { mapGetters } from "vuex";

export default {
  name: "app",
  components: {
    lottie: Lottie,
    arkidian: Arkidian
  },
  computed: {
    ...mapGetters(["pathAPI", "userLogged"])
  },
  data() {
    return {
      hayAvatar: true,
      indColor: false,
      indBody: false,
      indHair: false,
      indFace: false,
      preferencias: {
        animated: false,
        color: "",
        body: "",
        hair: "",
        face: "",
        avatar: ""
      },
      usuario: "aaaa",
      bodies: ["body", "body2", "body3", "body4", "body5", "body6"],
      faces: ["face1", "face2"],
      hairs: ["hair1", "hair2", "hair3", "hair4"],
      colors: [
        "#FF6F00",
        "#EF6C00",
        "#FF6D00",
        "#FF7043",
        "#FF5722",
        "#F4511E",
        "#E64A19",
        "#FF3D00",
        "#E57373",
        "#F44336",
        "#E53935",
        "#D32F2F",
        "#FF1744",
        "#EC407A",
        "#E91E63",
        "#D81B60",
        "#FF4081",
        "#F50057",
        "#AB47BC",
        "#BA68C8",
        "#D500F9",
        "#AA00FF",
        "#7E57C2",
        "#651FFF",
        "#5C6BC0",
        "#3D5AFE",
        "#2196F3",
        "#1E88E5",
        "#0288D1",
        "#40C4FF",
        "#448AFF",
        "#03A9F4",
        "#039BE5",
        "#00B0FF",
        "#00BCD4",
        "#00ACC1",
        "#26A69A",
        "#66BB6A",
        "#4CAF50",
        "#43A047",
        "#8BC34A",
        "#7CB342",
        "#558B2F",
        "#AFB42B",
        "#FBC02D",
        "#FDD835",
        "#8D6E63",
        "#757575",
        "#616161",
        "#90A4AE",
        "#78909C",
        "#607D8B"
      ]
    };
  },
  methods: {
    seleccionaColor(color) {
      this.preferencias.color = "fill:" + color;
      console.log(color);
    },
    seleccionaBody(body) {
      this.preferencias.body = body;
      console.log(body);
    },
    seleccionaFace(face) {
      this.preferencias.face = face;
      this.preferencias.animated = false;

      console.log(face);
    },
    seleccionaHair(hair) {
      this.preferencias.hair = hair;
      console.log(hair);
    },

    consultaAvatar(usuario) {
      var self = this;
      fetch(self.pathAPI + "arkidianUsuario.php?usuario=" + usuario)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          if (data.resultado == "ERROR") {
            self.preferencias.color =
              "fill:" + this.colors[this.randomInt(0, this.colors.length)];
            self.preferencias.body = this.bodies[
              this.randomInt(0, this.bodies.length)
            ];
            self.preferencias.hair = this.hairs[
              this.randomInt(0, this.hairs.length)
            ];
            self.preferencias.face = this.faces[
              this.randomInt(0, this.faces.length)
            ];
            console.log(self.preferencias);
          } else {
            self.preferencias.animated = true;
            self.preferencias.color = "fill:#" + data.color;
            self.preferencias.body = data.cuerpo;
            self.preferencias.hair = data.pelo;
            self.preferencias.face = data.cara;
          }
        });
    },
    randomInt(min, max) {
      return min + Math.floor((max - min) * Math.random());
    },

    modificaAvatar(preferencias, usuario) {
      console.log(preferencias);
      var bodyApi;
      bodyApi =
        "usuario=" +
        usuario +
        "&color=" +
        preferencias.color.substring(6, 12) +
        "&cara=" +
        preferencias.face +
        "&cuerpo=" +
        preferencias.body +
        "&pelo=" +
        preferencias.hair;
      console.log(bodyApi);
      fetch(this.pathAPI + "arkidianUsuario.php?" + bodyApi, {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
        .then(response => response.json())
        .then(data => {
          if (data.resultado == "OK") {
            this.userLogged.preferencias.color = preferencias.color;
            this.userLogged.preferencias.face = preferencias.face;
            this.userLogged.preferencias.body = preferencias.body;
            this.userLogged.preferencias.hair = preferencias.hair;
            this.preferencias.animated = true;
          } else {
            console.log(data);
          }
        });
    },

    altaAvatar(preferencias, usuario) {
      var self = this;
      //      self.errorMessage = "";
      //      self.successMessage = "";

      var bodyApi = "";

      bodyApi =
        "usuario=" +
        usuario +
        "&color=" +
        preferencias.color.substring(6, 12) +
        "&cara=" +
        preferencias.face +
        "&cuerpo=" +
        preferencias.body +
        "&pelo=" +
        preferencias.hair;

      fetch(this.pathAPI + "arkidianUsuario.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado == "ERROR") {
              //self.errorMessage = result.mensaje;
              console.log(result.mensaje);
            } else {
              self.userLogged.preferencias.color = preferencias.color;
              self.userLogged.preferencias.face = preferencias.face;
              self.userLogged.preferencias.body = preferencias.body;
              self.userLogged.preferencias.hair = preferencias.hair;
              self.preferencias.animated = true;
              self.hayAvatar = true;
            }
          });
        } else {
          self.errorMessage = "Hay un error, verificá los datos ingresados";
        }
      });
    }
  },
  mounted: function() {
    this.preferencias.color = this.userLogged.preferencias.color;
    this.preferencias.body = this.userLogged.preferencias.body;
    this.preferencias.face = this.userLogged.preferencias.face;
    this.preferencias.hair = this.userLogged.preferencias.hair;
    this.preferencias.animated = true;

    if (!this.preferencias.body) {
      this.hayAvatar = false;
      this.preferencias.color =
        "fill:" + this.colors[this.randomInt(0, this.colors.length)];
      this.preferencias.body = this.bodies[
        this.randomInt(0, this.bodies.length)
      ];
      this.preferencias.hair = this.hairs[this.randomInt(0, this.hairs.length)];
      this.preferencias.face = this.faces[this.randomInt(0, this.faces.length)];
    }
  }
};
</script>

<style scoped>
.avatar {
  width: 800px;
  justify-content: center;
  display: block;
  margin: auto;
}

@media screen and (max-width: 600px) {
  .avatar {
    width: 300px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sections/Avatar.vue